import Actions from "../action";

const DEFAULT_TIMEOUT = 30;

const initialState = {
  sessionTimeoutMinutes: DEFAULT_TIMEOUT,
  loading: false,
  error: null,
};

const SessionTimeoutReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case Actions.GET_SESSION_TIMEOUT:
      return { ...state, loading: true };
    case Actions.GET_SESSION_TIMEOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionTimeoutMinutes:
          action.data?.response?.session_timeout_minutes ?? state.sessionTimeoutMinutes,
      };
    case Actions.GET_SESSION_TIMEOUT_FAILURE:
      return { ...state, loading: false, error: action.data };
    case Actions.UPDATE_SESSION_TIMEOUT:
      return { ...state, loading: true };
    case Actions.UPDATE_SESSION_TIMEOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionTimeoutMinutes:
          action.data?.response?.session_timeout_minutes ?? state.sessionTimeoutMinutes,
      };
    case Actions.UPDATE_SESSION_TIMEOUT_FAILURE:
      return { ...state, loading: false, error: action.data };
    default:
      return state;
  }
};

export default SessionTimeoutReducer;
export const getSessionTimeoutMinutes = (state) =>
  state?.SESSION_TIMEOUT?.sessionTimeoutMinutes ?? DEFAULT_TIMEOUT;
